import { useAtomValue } from 'jotai';
import { activeHomeTabAtom } from '../states/homeTab.atom';

/**
 * 지정한 탭이 현재 활성 상태인지 여부.
 * TabView renderScene 하위 컴포넌트에서 "내가 지금 보이는 탭인지" 체크할 때 사용.
 *
 * 탭 `id`(= route.key) 를 넘기는 것을 권장한다. `screen_name` 은 유일하지 않아서
 * (CATEGORY_DEPARTMENT 처럼 default_query 만 다른 탭이 둘 있는 경우) 두 탭이 동시에
 * focused 로 판정된다. screen_name 이 유일한 CUSTOM 탭은 그대로 넘겨도 된다.
 */
export const useIsTabFocused = (tabIdOrScreenName: string): boolean => {
  const active = useAtomValue(activeHomeTabAtom);
  if (active == null) return false;
  return (
    active.id === tabIdOrScreenName || active.screen_name === tabIdOrScreenName
  );
};
